import { useContext } from "react";
import { SearchContext } from "@context/SearchContext";

const useSearchContext = () => {
    const ctx = useContext(SearchContext);
    if (!ctx) throw new Error("useSearch must be used within <SearchProvider>");
    return ctx;
};

export default useSearchContext;
